export const Links = {
    resume  :'https://rajivnayanc.github.io/resume-latex-overleaf/resume.pdf',
    blogs   :'https://blogs.rajivnayanc.com',
    email   :'rajivnayanc@gmail.com',
    socialmedia:[
        {
            name:'GitHub',
            link:'https://github.com/rajivnayanc',
            icon:'fab fa-github'
        },
        {
            name:'LinkedIn',
            link:'https://www.linkedin.com/in/rajivnayanc/',
            icon:'fab fa-linkedin'
        },
        {
            name:'YouTube',
            link:'https://www.youtube.com/c/TheLostCoders',
            icon:'fab fa-youtube'
        },
        {
            name:'Twitter',
            link:'https://twitter.com/rajivnayanc',
            icon:'fab fa-twitter'
        },
        
    ],
    github  :'https://github.com/rajivnayanc',
    logoCredit:{
        name:'Sorophics',
        link:'mailto:sorophics@gmail.com'
    }
}